export function handlePostcodeLookup(elem) {
    if (!elem) return;

    var input = document.getElementById('postcode');
    var list = document.getElementById('postcode-list');
    var agentContainer = document.getElementById('agent-info'); 
    var agentUrl = document.getElementById('calVisitLink');
    var agentOnlineUrl = document.getElementById('calConsultationLink');
    var controller = null;

    if (!input || !list || !agentContainer) return;

    // Hide initially
    hideAgentContainer();

    input.addEventListener('input', onInput);
    list.addEventListener('click', onSelect);

    function onInput() {
        var value = input.value.trim();

        // Hide agent info if less than 2 chars
        if (value.length < 2) {
            clearResults();
            hideAgentContainer();
            return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(value) + '/autocomplete', {
            signal: controller.signal
        })
        .then(res => res.json())
        .then(data => {
            if (data.status === 200 && data.result) {
                renderResults(data.result);
            } else {
                clearResults();
            }
        })
        .catch(err => {
            if (err.name !== 'AbortError') clearResults();
        });
    }

    function renderResults(results) {
        list.innerHTML = '';
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');

        results.forEach(postcode => {
            var item = document.createElement('li');
            item.textContent = postcode;
            item.setAttribute('role', 'option');
            list.appendChild(item);
        });
    }

    async function onSelect(event) {
        if (event.target.tagName !== 'LI') return;

        var selectedPostcode = event.target.textContent;
        input.value = selectedPostcode;
        clearResults();
        
        let result = await fetchAgentForPostcode(selectedPostcode);

        if (result) {
            // 🔥 Dispatch event
            input.dispatchEvent(new CustomEvent('postcode:selected', {
                detail: {
                    postcode: selectedPostcode
                }
            }));
        }
        else {
            input.dispatchEvent(new CustomEvent('postcode:error'));
        }
    }

    function clearResults() {
        list.innerHTML = '';
        list.hidden = true;
        input.setAttribute('aria-expanded', 'false');
    }

    async function fetchAgentForPostcode(postcode) {
        let response = await fetch('/umbraco/api/salesagents/get?postcode=' + encodeURI(postcode))
            .then((response) => {
                return response.json();
            })
            .catch((error) => {
                // this doesn't fire on a bad request...huh.
            });   

        let agent = response;
        if (agent.visitUrl) {
            showAgent(agent);
            return true;
        }
        else {            
            hideAgentContainer();
        }

        return false;
    }

    function showAgent(agent) {
        // Store base URL for later use
        input.dataset.agentUrl = agent.visitUrl;
        input.dataset.agentOnlineUrl = agent.onlineUrl;
    }

    function hideAgentContainer() {
        agentContainer.innerHTML = '';
        agentContainer.hidden = true; // Hide from visual and assistive tech
        agentUrl.href = '';
    }
}
